




































import { Component, Prop, Vue } from 'vue-property-decorator';
import CalcManualDialog from '@/components/calculator/CalcManualDialog.vue';
import BlankoCardDialog from '@/components/util/BlankoCardDialog.vue';
@Component({
  components: {
    zaBlankoDialog: BlankoCardDialog
  }
})
export default class BlankoCard extends Vue {
  hoverOrDraggingOver: boolean = false;
  dialog: boolean = false;
  activateDialog() {
    this.dialog = true;
  }
  deactivateDialog() {
    this.dialog = false;
  }
}
